import { GOOGLE_MAPS_CALLBACK_NAME } from 'constants/googlemaps';

// prevents GMaps from throwing
(window as any)[GOOGLE_MAPS_CALLBACK_NAME] = () => {};
